import { FC, useEffect } from "preact/compat";
import { useApp } from "~/core/store";

const Meta: FC = () => {
    const {
        meta: { title, prefix },
    } = useApp();

    useEffect(() => {
        const docTitle = prefix.value
            ? `${prefix.value} ${title.value}`
            : title.value;

        document.title = docTitle;
    }, [title.value, prefix.value]);

    return null;
};

export default Meta;
